import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'; // Make sure to import NavLink
import './NavigationBar.scss';

function NavigationItem({ title, content, isOpen, setIsOpen, href }) {
  const toggleDropdown = (e) => {
    e.stopPropagation(); // Stop click event from propagating to the document
    setIsOpen(isOpen ? null : title);
  };

  // Use NavLink for navigation items with a href
  const link = href ? (
    <NavLink to={href} className={({ isActive }) => "nav-title" + (isActive ? " active" : "")}>
      {title}
    </NavLink>
  ) : (
    <button className="nav-title" onClick={toggleDropdown}>{title}</button>
  );

  return (
    <div className="nav-item">
      {link}
      {isOpen && !href && <div className="dropdown-content">{content}</div>}
    </div>
  );
}

function NavigationBar() {
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const closeDropdown = (e) => {
      // Close the dropdown if clicked outside of it
      if (!e.target.closest('.dropdown-content') && !e.target.closest('.nav-title')) {
        setOpenDropdown(null);
      }
    };

    // Add click event listener
    document.addEventListener('click', closeDropdown);
    return () => {
      // Remove click event listener on cleanup
      document.removeEventListener('click', closeDropdown);
    };
  }, [openDropdown]);

  const promotionContent = (
    <ul>
      <li>Promotion 1</li>
      <li>Promotion 2</li>
      <li>Promotion 3</li>
      <li>Promotion 4</li>
      <li>Promotion 5</li>
    </ul>
  );

  const navItems = [
    { title: "Latest News", href: '/Groupe' }, // Assuming '/news' is the route you want to navigate to
    { title: "All live", href: '/Rassemble' },  // Assuming '/live' is the route you want to navigate to
    { title: "Official offer", content: promotionContent },
  ];

  return (
    <div className="navigation-bar">
      <div className="branding">        
        <span className="brand-name">TD</span>
      </div>
      <div className="nav-items">
        {navItems.map(item => (
          <NavigationItem
            key={item.title}
            title={item.title}
            content={item.content}
            isOpen={openDropdown === item.title}
            setIsOpen={setOpenDropdown}
            href={item.href}
          />
        ))}
      </div>
    </div>
  );
}

export default NavigationBar;
